<template>
  <button class="share-container" @click="shareLink">
    <AtomicUiIcon :icon="csgShareIos" size="s" />
    <div class="medium padding-left-xxs padding-right-s seperator">Share</div>
  </button>
</template>

<script setup>
import { csgShareIos } from '@csgSvgIcons/icons';
import Toast from '@nuxt-common/atomic-ui/app/components/toast';
import { fireTag } from '@nuxt-common/util/app/utils/tagManager';

const { wishlistGuid } = useWishlistDetails();

const isToastShowing = ref(false);
const toastOptions = {
  placement: 'bottom',
  duration: 3000,
  showCloseIcon: true,
  onClose: () => {
    isToastShowing.value = false;
  },
};
const shareLink = async () => {
  if (isToastShowing.value) {
    return;
  }
  isToastShowing.value = true;
  try {
    const shareableLink = `${window.location.origin}/wishlist/mylist?listGuid=${wishlistGuid.value}`;
    await navigator.clipboard.writeText(shareableLink);
    Toast({ ...toastOptions, message: 'Link copied' });
  } catch {
    Toast({ ...toastOptions, message: 'Failed to copy link' });
  }
  fireTag('link', {
    event_name: 'wishlist share',
    link_name: 'wishlist share',
    wishlist_id: wishlistGuid.value,
  });
};
</script>

<style lang="scss" scoped>
.share-container {
  cursor: pointer;
  display: flex;
}

div.seperator {
  position: relative;
  &:before {
    content: '';
    height: rem-calc(13);
    width: rem-calc(1);
    position: absolute;
    left: rem-calc(57);
    top: rem-calc(4);
    background-color: $gray-4-color;
  }
}
</style>
